module.exports = __webpack_public_path__ + "static/media/footer-notifications.48ede22f.png";